module.exports = __webpack_public_path__ + "img/phoenix-logo.8c12473a.png";